/* CHAPMAN GOLD: THE ONE MARKETS CLIENT.  26 Aug 2026.

   WHY THIS EXISTS. On 26 Aug 2026 the site showed two different gold prices on one page:
   the header ticker said 108.66 and the "what is your gold worth" calculator said 109.04.
   They were not the same number because they were not the same SOURCE. The ticker fetched
   api.gold-api.com and open.er-api.com; the calculator fetched our own markets worker.
   The ticker also never refreshed: it was called once on page load and that was that.

   Fenn's ruling: "there should be 0% drift allowed."

   Same source is not enough for that. Two fetches at two instants can straddle a worker
   update and still disagree. So this file makes ONE fetch and hands the SAME derived
   numbers to every subscriber on the page. Zero drift by construction, not by luck.

   STANDING LAW 0: spot comes from the markets feed, fetched live, never from a file and
   never from a third party. This is the only place on the website that fetches it.

   THE ONE FORMULA. The feed gives grams of fine gold per unit of currency. Gold per gram
   fine is 1 / GBP.grams. Everything else derives from that. Never goldUsdOz with a separate
   FX call: that is two sources wearing one coat.

   USE IT (order does not matter, the queue drains itself):
     (window.CGMarketsQ = window.CGMarketsQ || []).push(function (m, err) {
       if (!m) return;                      // never loaded, leave the placeholder alone
       el.textContent = window.CGMarkets.money(m.goldPerGram);
     });
   The callback fires on first load and again on every refresh. On a failed refresh it fires
   with (lastGoodValue, error) so a display keeps its last honest number instead of blanking.
*/
(function () {
  'use strict';
  if (window.CGMarkets) return;

  var FEED = 'https://chapman-gold-markets.fennmchapman.workers.dev/api/live';
  var REFRESH_MS = 60000;          // the worker itself updates every 2 minutes
  var OZ = 31.1034768;             // troy ounce in grams

  var MIN_GAP_MS = 15000;          // never hit the worker more often than this
  var subs = [], last = null, inflight = null, lastFetchAt = 0;

  function derive(j) {
    var by = {}, i;
    var items = j.items || [];
    for (i = 0; i < items.length; i++) by[items[i].id] = items[i];
    var gbp = by.GBP && by.GBP.grams;
    if (!(gbp > 0)) throw new Error('markets feed carried no GBP leg');
    var perGram = 1 / gbp;
    function ozOf(id) { return (by[id] && by[id].grams > 0) ? by[id].grams / gbp : null; }
    return {
      ts: j.ts,
      ok: j.ok,
      items: items,
      fetchedAt: Date.now(),
      goldPerGram: perGram,
      goldPerOz: perGram * OZ,
      silverPerOz: ozOf('XAG'),
      platinumPerOz: ozOf('XPT'),
      palladiumPerOz: ozOf('XPD'),
      goldUsdOz: j.goldUsdOz,
      carat: function (millesimal) { return perGram * millesimal; }
    };
  }

  function notify(err) {
    var snapshot = subs.slice();
    for (var i = 0; i < snapshot.length; i++) {
      try { snapshot[i](last, err || null); } catch (e) {}
    }
  }

  function refresh() {
    if (inflight) return inflight;
    lastFetchAt = Date.now();
    var done = function () { inflight = null; };
    inflight = fetch(FEED, { cache: 'no-store' })
      .then(function (r) {
        if (!r.ok) throw new Error('markets feed HTTP ' + r.status);
        return r.json();
      })
      .then(function (j) { last = derive(j); notify(null); return last; })
      .then(function (v) { done(); return v; },
            function (e) { done(); notify(e); throw e; });
    return inflight;
  }

  function subscribe(fn) {
    if (typeof fn !== 'function') return function () {};
    subs.push(fn);
    if (last) { try { fn(last, null); } catch (e) {} }
    else { refresh()['catch'](function () {}); }
    return function () {
      var i = subs.indexOf(fn);
      if (i >= 0) subs.splice(i, 1);
    };
  }

  // THROTTLED ON PURPOSE (26 Aug 2026). The first cut refreshed on every visibilitychange
  // with no floor, and a browser that flickers visible/hidden turned a 60 second poll into a
  // fetch every 2 seconds. A visitor flipping tabs would do the same thing more slowly. The
  // interval and the visibility handler now share one floor, so neither can outrun it.
  function tick() {
    if (document.hidden) return;               // do not poll a tab nobody is looking at
    if (Date.now() - lastFetchAt < MIN_GAP_MS) return;
    refresh()['catch'](function () {});
  }

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) tick();              // come back to a fresh number, not a stale one
  });
  setInterval(tick, REFRESH_MS);

  window.CGMarkets = {
    subscribe: subscribe,
    refresh: refresh,
    snapshot: function () { return last; },
    money: function (x) {
      return '£' + Number(x).toLocaleString('en-GB',
        { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    feedUrl: FEED
  };

  // Drain whatever queued before this file finished loading, then make the queue immediate.
  var queued = window.CGMarketsQ || [];
  window.CGMarketsQ = { push: subscribe };
  for (var k = 0; k < queued.length; k++) subscribe(queued[k]);
  refresh()['catch'](function () {});
})();
